import React from 'react'
import { styled } from '~/app/components'
import InformationPanel, { TitleDescription } from './InformationPanel'
import SubHeader from '~/app/components/common/SubHeader/SubHeader'

/**
 * GuestInformation component
 * author: soojin.oh
 */

// type definitions
type Props = {
  guest: Array<TitleDescription>
} & Pick<React.HTMLProps<HTMLDivElement>, 'style'>

// styled components
const Container = styled.div`
  position: relative;
  background: ${({ theme }) => theme.color.white};
  border-bottom: 1px solid ${({ theme }) => theme.color.gray200};
  padding-bottom: 2rem;
`

// GuestInformation component
const GuestInformation: React.FC<Props> = function ({ guest, style }) {
  return (
    <Container style={style}>
      <SubHeader title="이용자 정보" hasBottomContent />
      <InformationPanel information={guest} />
    </Container>
  )
}

export default GuestInformation
